import React from 'react';
import './about.scss';

const About = () => {
    return (
        <div className="about-page">
            <div className="post">
                <h1>Our Story</h1>
                
                <figure className="award-feature">
                    <img 
                        src="https://afag.imgix.net/domenicos-italian-restaurant/la-best-award.jpg?w=1000&auto=format" 
                        alt="LA's Best Award - Domenico's Italian Restaurant" 
                    />
                    <figcaption>Featured in LA's Best</figcaption>
                </figure>
           
                <p>
                    Domenico's is a 3rd generation family restaurant that makes pizza the way you want. Every dinner is made with Mama Rosa's original recipes. We are known for our pizzas and our mouthwatering antipasto salad with our homemade Italian dressing. Domenico's is Pasadena's oldest Italian restaurant. We are entirely dedicated to providing our guests with the very finest quality cuisine, exceptional service and genuine hospitality.
                </p>
                
                <h2>History</h2>
                <p className="established">Established in 1960.</p>
                
                <figure className="family-photo">
                    <img 
                        src="https://afag.imgix.net/domenicos-italian-restaurant/old-family-photo.jpg?w=1000&auto=format" 
                        alt="The Domenico's family - three generations of Italian cooking" 
                    />
                    <figcaption>Three generations of family tradition</figcaption>
                </figure>

                <figure className="family-photo">
                    <img 
                        src="https://afag.imgix.net/domenicos-italian-restaurant/wall-menu.jpg?w=1000&auto=format" 
                        alt="Original wall menu from Domenico's Italian Restaurant" 
                    />
                    <figcaption>Our original wall menu</figcaption>
                </figure>
                
                <p>
                    For over 50 years, Domenico's has been proudly serving the Pasadena area. Not many restaurants are able to say they've been around for half a century, but at Domenico's we know this is a product of our dedication to delicious food, friendly customer service, and a quality dining experience. Here's to hoping for over 50 more!
                </p>
            </div>
        </div>
    );
};

export default About;
